import React, { useEffect, useState } from 'react';
import { LogoMark } from './ui/LogoMark';

function Logo() {
  return (
    <a href="#top" data-cursor style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <LogoMark size={38} />
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 16, letterSpacing: '-0.02em' }}>
        Bernardo<span style={{ color: 'var(--text-muted)' }}> Assad</span>
      </span>
    </a>
  );
}

const LINKS = [
  ['Sobre', '#sobre'],
  ['Experiência', '#experiencia'],
  ['Projetos', '#projetos'],
  ['Skills', '#skills'],
  ['Arquitetura', '#arquitetura'],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 900,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: scrolled ? '12px clamp(20px, 5vw, 56px)' : '22px clamp(20px, 5vw, 56px)',
      background: scrolled ? 'color-mix(in oklab, var(--ink-950) 72%, transparent)' : 'transparent',
      backdropFilter: scrolled ? 'var(--blur-md)' : 'none',
      WebkitBackdropFilter: scrolled ? 'var(--blur-md)' : 'none',
      borderBottom: scrolled ? '1px solid var(--border-subtle)' : '1px solid transparent',
      transition: 'all var(--dur-base) var(--ease-out)' }}>
      <Logo />
      <nav style={{ display: 'flex', alignItems: 'center', gap: 'clamp(14px, 2vw, 30px)' }}>
        {LINKS.map(([label, href]) => (
          <a key={href} href={href} className="nav-link" data-navlink style={{
            fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', letterSpacing: '0.06em',
            color: 'var(--text-secondary)', textTransform: 'uppercase', transition: 'color var(--dur-fast) var(--ease-out)' }}>
            {label}
          </a>
        ))}
        <a href="#contato" data-cursor style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, padding: '9px 18px',
          borderRadius: 'var(--radius-pill)', border: '1.5px solid var(--border-accent)',
          color: 'var(--accent)', fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 14,
          transition: 'all var(--dur-fast) var(--ease-out)' }}
          onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--accent)'; e.currentTarget.style.color = '#000'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--accent)'; }}>
          Contato
        </a>
      </nav>
    </header>
  );
}
